<template>
  <div class="mt-16 animate__animated animate__fadeIn">
    <v-container>
      <v-row v-show="device.mobile">
        <v-col cols="12">
          <v-carousel
            cycle
            :height="device.desktop ? `350` : `350`"
            hide-delimiter-background
            :show-arrows="false"
          >
            <v-carousel-item
              v-for="(slide, i) in sliders"
              :key="i"
              :src="slide.path"
            >
              <v-col
                cols="6"
                v-show="device.desktop"
              >
                <v-row>
                  <div class="bg-black">
                    <div class="container-title">
                      <div class="flex flex-column">
                        <div
                          v-if="slide.top_image_status"
                          class="slider-title animated animate__fadeInUpBig animate__delay-5s"
                        >
                          <img
                            :src="slide.top_image_path"
                            alt=""
                            height="50px"
                            srcset=""
                          >
                        </div>
                        <div class="slider-title animated animate__lightSpeedInRight">
                          {{ slide.title }}
                        </div>
                        <div class="slider-sub-title animated animate__fadeInUp">

                          {{ slide.content }}
                        </div>
                        <v-row>
                          <div class="slider-action">
                            <v-btn
                              rounded
                              color="green"
                              dark
                              large
                              v-show="false"
                              @click="$router.push({name:'registrasi'})"
                            >Registrasi</v-btn>

                          </div>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-row>
              </v-col>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title class="blue white--text">
              <v-icon class="mr-2 white--text">mdi-view-headline</v-icon>
              Semua Kategori</v-card-title>
            <v-card-text>
              <v-list
                dense
                nav
                shaped
              >

                <template v-for="(menu, index) in categories">
                  <v-list-item
                    active-class="orange darken-4"
                    :to="menu.route"
                    :key="index"
                    v-if="menu.type === 'item'"
                  >
                    <v-list-item-action>
                      <v-icon>{{ menu.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ menu.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider v-if="menu.type=='divider'"></v-divider>

                  <v-list-group
                    v-if="menu.type == 'subMenu'"
                    dark
                    active-class="blue--text"
                  >
                    <template v-slot:activator>
                      <v-list-item-action>
                        <v-icon class="">{{ menu.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title> {{ menu.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      v-for="(subItem,idx) in menu.submenus"
                      active-class="orange darken-4"
                      :key="idx"
                      v-if="subItem.type === 'item'"
                      class="animate__animated animate__flipInY"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>

                  <v-subheader
                    :class="menu.class"
                    :key="index"
                    class="overline mt-3"
                    style="height: 24px"
                    v-else-if="menu.type === 'subheader'"
                  >{{ menu.title }}</v-subheader>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>

      <v-row v-show="device.desktop">
        <v-col cols="4">
          <v-card>
            <v-card-title class="blue white--text">
              <v-icon class="mr-2 white--text">mdi-view-headline</v-icon>
              Semua Kategori</v-card-title>
            <v-card-text>
              <v-list
                dense
                nav
                shaped
              >

                <template v-for="(menu, index) in categories">
                  <v-list-item
                    active-class="orange darken-4"
                    :to="menu.route"
                    :key="index"
                    v-if="menu.type === 'item'"
                  >
                    <v-list-item-action>
                      <v-icon>{{ menu.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ menu.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider v-if="menu.type=='divider'"></v-divider>

                  <v-list-group
                    v-if="menu.type == 'subMenu'"
                    dark
                    active-class="blue--text"
                  >
                    <template v-slot:activator>
                      <v-list-item-action>
                        <v-icon class="">{{ menu.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title> {{ menu.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      v-for="(subItem,idx) in menu.submenus"
                      active-class="orange darken-4"
                      :key="idx"
                      v-if="subItem.type === 'item'"
                      class="animate__animated animate__flipInY"
                      @click="loadCategory(subItem.id)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>

                  <v-subheader
                    :class="menu.class"
                    :key="index"
                    class="overline mt-3"
                    style="height: 24px"
                    v-else-if="menu.type === 'subheader'"
                  >{{ menu.title }}</v-subheader>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="8">
          <v-carousel
            cycle
            :height="device.desktop ? `350` : `350`"
            hide-delimiter-background
            :show-arrows="false"
          >
            <v-carousel-item
              v-for="(slide, i) in sliders"
              :key="i"
              :src="slide.path"
            >
              <v-col
                cols="6"
                v-show="device.desktop"
              >
                <v-row>
                  <div class="bg-black">
                    <div class="container-title">
                      <div class="flex flex-column">
                        <div
                          v-if="slide.top_image_status"
                          class="slider-title animated animate__fadeInUpBig animate__delay-5s"
                        >
                          <img
                            :src="slide.top_image_path"
                            alt=""
                            height="50px"
                            srcset=""
                          >
                        </div>
                        <div class="slider-title animated animate__lightSpeedInRight">
                          {{ slide.title }}
                        </div>
                        <div class="slider-sub-title animated animate__fadeInUp">

                          {{ slide.content }}
                        </div>
                        <v-row>
                          <div class="slider-action">
                            <v-btn
                              rounded
                              color="green"
                              dark
                              large
                              v-show="false"
                              @click="$router.push({name:'registrasi'})"
                            >Registrasi</v-btn>

                          </div>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-row>
              </v-col>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
      <v-row class="">
        <!-- <v-col
          cols="12"
          class=""
        >
          <best-market />
        </v-col>
        <v-col cols=12>
          <v-divider></v-divider>
        </v-col>
        <v-col
          cols=12
          class="animate__animated animate__fadeIn animate__delay-1s  ml-5 mr-5"
          v-show="false"
        >
          <div class=" ant-font-viga">Berdasarkan Pencarianmu</div>
          <div class="mt-5 body-2">Menampilkan 1 - 14 produk dari total 14</div>
          <v-row class="mt-5">
            <v-col
              cols="2"
              v-for="item in productfilters"
            >
              <div class="ant-market-box-product">
                <img
                  :src="item.image"
                  alt=""
                  srcset=""
                  height="175"
                  width="100%"
                >
                <div
                  style=""
                  class="ant-market-box-product-content"
                  @click="$router.push({name:'product-detail'})"
                >
                  <div>
                    {{ item.name }}
                  </div>
                  <div class="mt-1">
                    <v-icon
                      small
                      color="blue"
                      class="mr-1"
                    >mdi-home-map-marker</v-icon> {{ item.location }}
                  </div>
                  <div class="mt-1">
                    <v-icon
                      small
                      color="orange"
                      class="mr-1"
                    >mdi-medal</v-icon> {{ item.rate }} | Review : {{ item.review }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
      <v-col
        cols="12"
        class="mt-10"
      >
        <v-divider></v-divider>
        <v-tabs
          color="blue"
          v-model="tab"
        >
          <v-tab class="blue--text ant-font-viga text-transform-none"><v-icon
              class="mr-2"
              key="page-product"
            >mdi-gift</v-icon> Produk</v-tab>
          <v-tab class="blue--text ant-font-viga"><v-icon
              class="mr-2"
              key="page-umkm"
            >mdi-storefront</v-icon>UP2K PKK</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key=page-product>
            <v-row class="mt-2 ml-5 mr-5">
              <div class="mt-5 body-2 grey--text">Total Produk {{ products_total }}</div>
              <v-spacer></v-spacer>
              <div class="mt-3 mr-2">Urutkan : </div>
              <v-select
                class="mt-1"
                outlined
                dense
                hide-detail
                color="blue"
                style="max-width: 300px;"
                :items="urutans"
                v-model="sortBy"
                @change="loadSortBy"
              ></v-select>
            </v-row>
            <v-row class="mt-5 pl-3">
              <v-col
                :cols="device.desktop ? 2: 12"
                v-for="(item,index) in filterItems"
                :kety="index"
              >
                <div
                  class="ant-market-box-product"
                  @click="openProductDetail(item.id)"
                >
                  <div>
                    <img
                      :src="item.image_path"
                      alt=""
                      srcset=""
                      height="175"
                      width="100%"
                    >
                    <div
                      v-show="item.unggulan"
                      class="ant-market-product-best"
                    >
                      UNGGULAN
                    </div>
                  </div>
                  <div
                    style=""
                    class="ant-market-box-product-content"
                  >
                    <div class="font-weight-bold pl-1">
                      {{ item.price }}
                    </div>
                    <div class="pl-1">
                      {{ item.name }}
                    </div>
                    <div class="mt-1">
                      <v-icon
                        small
                        color="blue"
                        class="mr-1"
                      >mdi-home-map-marker</v-icon>
                      <span style="font-size: 7pt;">

                        {{ item.location }}
                      </span>
                    </div>
                    <div class="mt-1">
                      <v-icon
                        small
                        color="orange"
                        class="mr-1"
                      >mdi-medal</v-icon>
                      <span style="font-size: 7pt;">
                        {{ item.rate }} | Review : {{ item.review }}
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12">
                <div class="flex text-center">
                  <v-btn
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    @click="loadMoreProducts"
                  >Muat Lebih Banyak</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item key=page-umkm>
            <div class="mt-5 ml-5 body-2">Menampilkan 1 - {{ tokos.length }} UP2K PKK dari total {{ tokos.length }}</div>
            <v-card flat>
              <v-row class="mt-5 pl-3 pr-3">
                <v-col
                  :cols="device.desktop ? 4:12"
                  v-for="(toko,index) in tokos"
                >
                  <div style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);height: 220px; border-radius: 10px; padding: 5px;">
                    <div style="display: flex; flex-direction: row; margin-top: 5px;">
                      <div class="mr-2">
                        <img
                          :src="toko.logo"
                          alt=""
                          srcset=""
                          height="50"
                          width="48"
                        >
                      </div>
                      <div class="body-2">
                        <div class="font-weight-bold">{{ toko.name }}</div>
                        <div style="font-size: 7pt;">{{ toko.location }}</div>
                        <v-chip
                          x-small
                          class="white--text"
                          :color="toko.status.color"
                        ><span>{{ toko.status.text }}</span></v-chip>
                      </div>
                      <v-spacer></v-spacer>
                      <div>
                        <v-btn
                          outlined
                          dense
                          hide-details
                          color="blue"
                          class="ant-font-viga"
                          @click="openToko(toko.id)"
                        >Lihat UP2K PKK</v-btn>
                      </div>
                    </div>
                    <v-row class="mt-1">
                      <v-col
                        cols="4"
                        v-for="(item, index) in toko.products"
                        :key="index"
                        v-if="index < 3"
                      >
                        <div style="height: 80px; overflow: hidden; border-radius: 5px;">
                          <img
                            :src="item.image"
                            alt=""
                            width="100%"
                            height="80"
                          >

                        </div>
                        <div style="font-size: 10pt; color: blue; font-weight: bold;">
                          {{ item.price }}
                        </div>
                      </v-col>
                    </v-row>

                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col>
                  <div class="text-center">
                    <v-btn
                      outlined
                      dense
                      hide-details
                      :color="theme.color"
                    >Muat Lebih Banyak</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import "animate.css";
import BestMarket from "../best-market/Index.vue";

export default {
  name: "product",
  components: {
    BestMarket,
  },
  data: () => ({
    uname: "",
    upass: "",
    visible: false,
    color: "blue darken-3",
    jmlpendaftar: 0,
    jmllakilaki: 0,
    jmlperempuan: 0,

    pengumuman: {
      title: null,
      body: null,
    },
    sliders: [],

    lightToolbar: true,
    tab: null,
    page: 1,
    urutans: [
      {
        text: "Paling Sesuai",
        value: "paling-sesuai",
      },
      {
        text: "Termurah",
        value: "termurah",
      },
      {
        text: "Termahal",
        value: "termahal",
      },
    ],
    productfilters: [],
    products: [],
    products_total: null,
    products_page: 1,
    tokos: [],
    categories: [],
    sortBy: "paling-sesuai",
    category: null,
  }),
  mounted() {
    this.setPage({
      crud: true,
    }).then(() => {
      this.getAppInfo().then(() => {
        window.document.title = this.info.app_company;
        const favicon = window.document.getElementById("favicon");
        favicon.href = this.info.app_logo;
      });
    });
    this.fetchSliders();
    this.fetchMenuCategory();
    this.fetchProducts();
    this.fetchUP2K();
  },
  computed: {
    ...mapState([
      "device",
      "info",
      "snackbar",
      "device",
      "http",
      "theme",
      "search",
    ]),

    contentStyle: function () {
      if (!this.device.mobile && this.info.apps_background) {
        return `background: url(${this.info.apps_background});
                            background-position: center center;
                            background-repeat: no-repeat;
                            background-size: cover;`;
      }
      return ``;
    },

    filterItems() {
      if (this.search != null) {
        return this.products.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        return this.products;
      }
    },
  },
  methods: {
    ...mapActions([
      "setPage",
      "getAppInfo",
      "signIn",
      "snackbarClose",
      "getAppInfo",
    ]),
    onScroll: function (event) {
      if (window.pageYOffset >= window.innerHeight - 350) {
        if (this.lightToolbar === true) this.lightToolbar = false;
      } else {
        if (this.lightToolbar === false) this.lightToolbar = true;
      }
    },

    postRegister: function () {
      this.$router.push({ name: "register" });
    },

    fetchPengumuman: async function () {
      let { data } = await this.http.get("pengumuman");

      this.pengumuman = data;
    },
    fetchSliders: async function () {
      let { data } = await this.http.get("sliders");

      this.sliders = data;
    },
    fetchMenuCategory: async function () {
      let { data } = await this.http.get("menu-category");

      this.categories = data;
    },
    fetchProducts: async function () {
      let {
        data: { data, total },
      } = await this.http.get(
        "list-product/" +
          this.products_page +
          "/" +
          this.sortBy +
          "/" +
          this.category
      );
      data.forEach((element) => {
        this.products.push(element);
      });

      this.products_total = total;
    },
    loadMoreProducts: async function () {
      this.products_page = this.products_page + 1;
      this.fetchProducts();
    },
    loadSortBy: function () {
      this.products = [];
      this.products_page = 1;
      this.fetchProducts();
    },
    loadCategory: function (val) {
      this.products = [];
      this.category = val;
      this.products_page = 1;
      this.fetchProducts();
    },
    fetchUP2K: async function () {
      let { data } = await this.http.get("list-company-public");
      this.tokos = data;
    },
    openProductDetail: async function (val) {
      this.$router.push({
        name: "product-detail",
        params: {
          id: val,
        },
      });
    },
    openToko: function (val) {
      this.$router.push({
        name: "umkm",
        params: {
          id: val,
        },
      });
    },
  },
  watch: {
    search: function () {
      this.filterItems();
    },
  },
};
</script>
<style>
</style>